import React, { Component } from 'react';


class Learn extends Component {
    render() {
        return (
            <div style={{textAlign:"center"}}>
                <h1>The Learn page is still under construction!</h1>

            </div>


        )
    }
}
export default Learn;